module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mobile-menu-wrapper"
  }, [(_vm.dataLoad) ? _c('nav', [(_vm.screenWidth > 639) ? _c('navigation-desctop', {
    attrs: {
      "data-params": _vm.menuData,
      "screen-width": _vm.screenWidth
    }
  }) : (_vm.screenWidth <= 639) ? _c('navigationMobile', {
    attrs: {
      "data-params": _vm.menuData
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58715a90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/Navigation.vue
// module id = 161
// module chunks = 25